import React from 'react';
import { motion } from 'framer-motion';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    emoji: '🎉',
    title: 'BONO 1 — Adiós al aburrimiento',
    desc: '52 planes mágicos para toda la familia. Una idea nueva cada semana del año.',
    value: '$5.000'
  }, {
    num: '02',
    emoji: '🗝️',
    title: 'BONO 2 — Juegos para descubrir lo que tu hija siente',
    desc: 'Juegos diseñados para abrir conversaciones profundas de forma divertida.',
    value: '$5.000'
  }, {
    num: '03',
    emoji: '💌',
    title: 'BONO 3 — 30 cosas que quiero que mi hija nunca olvide',
    desc: 'Frases y actividades para dejar una huella emocional imborrable.',
    value: '$5.000'
  }, {
    num: '04',
    emoji: '👵',
    title: 'BONO 4 — Abuelita, cuéntame tu historia',
    desc: 'Un libro para que los abuelos compartan sus recuerdos y sabiduría con la familia.',
    value: '$5.000'
  }, {
    num: '05',
    emoji: '👴',
    title: 'BONO 5 — Abuelito, cuéntame tu historia',
    desc: 'Un libro para que los abuelos compartan sus vivencias y enseñanzas.',
    value: '$5.000'
  }, {
    num: '06',
    emoji: '👩',
    title: 'BONO 6 — Mamá, cuéntame tu historia',
    desc: 'Un espacio para que mamá comparta su historia, sueños y aprendizajes.',
    value: '$5.000'
  }, {
    num: '07',
    emoji: '👨',
    title: 'BONO 7 — Papá, cuéntame tu historia',
    desc: 'Un espacio para que papá comparta su historia, sueños y aprendizajes.',
    value: '$5.000'
  }];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden" data-id="element-19">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-gold-500/5 to-transparent pointer-events-none" data-id="element-20" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-23">
            <span data-id="element-24">🎁</span> 7 BONOS EXCLUSIVOS
          </h2>
          <div className="inline-block bg-gold-500/20 text-gold-400 font-bold px-4 py-1.5 rounded-full text-lg tracking-widest" data-id="element-25">
            SOLO SI ACCEDÉS HOY
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-26">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className="bg-navy-800 border border-navy-600 rounded-2xl p-5 md:p-6 relative overflow-hidden group hover:border-gold-500/50 transition-colors" data-id="element-27">
              <div className="absolute -right-4 -top-4 text-6xl md:text-8xl font-black text-navy-700/50 group-hover:text-navy-700 transition-colors" data-id="element-28">
                {bonus.num}
              </div>

              <div className="relative z-10" data-id="element-29">
                <div className="text-3xl mb-4" data-id="element-30">{bonus.emoji}</div>
                <h3 className="text-xl font-bold text-white mb-3 pr-8" data-id="element-31">
                  {bonus.title}
                </h3>
                <p className="text-slate-400 text-sm mb-6 min-h-[80px]" data-id="element-32">
                  {bonus.desc}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-navy-700" data-id="element-33">
                  <span className="text-slate-500 line-through text-sm" data-id="element-34">
                    {bonus.value}
                  </span>
                  <span className="bg-green-500/20 text-green-400 font-bold px-3 py-1 rounded text-sm" data-id="element-35">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.3
      }} className="bg-gradient-to-r from-gold-600/20 via-gold-500/20 to-gold-600/20 border border-gold-500/30 rounded-2xl p-8 text-center max-w-3xl mx-auto glow-gold" data-id="element-36">
          <p className="text-xl md:text-2xl font-medium text-slate-300" data-id="element-37">
            Valor total bonos{' '}
            <span className="line-through text-slate-500 mx-2" data-id="element-38">$35.000</span>
            <span className="text-gold-400 font-bold block md:inline mt-2 md:mt-0" data-id="element-39">
              → GRATIS con tu Pack 100 Citas
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}